import { createSlice } from '@reduxjs/toolkit';
import { doGetAllOrderStats } from './thunk';

// Define the initial state structure
const initialState = {
  isFetching: false,
  performanceData: null, // Store the orderStats array directly
};

const analyticsSlice = createSlice({
  name: 'analytics',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(doGetAllOrderStats.fulfilled, (state, action) => {
      state.performanceData = action.payload;
      state.isFetching = false;
    });
    builder.addCase(doGetAllOrderStats.pending, (state) => {
      state.isFetching = true;
    });
  },
});

export const selectAllOrderStats = (state) => state.analytics.performanceData; // Selector to access orderStats

export default analyticsSlice.reducer;
